import { GlassSurface } from '@components/glass/GlassSurface';
import { Chip } from '@components/ui/Chip';
import { TECH_GROUPS } from '@config/content';

import styles from './StackShowcase.module.scss';

/** The technology stack, one labelled row per discipline. */
export const StackShowcase = () => (
  <GlassSurface refract={false} className={styles.panel} data-reveal="">
    <dl className={styles.groups}>
      {TECH_GROUPS.map((group) => (
        <div key={group.label} className={styles.group}>
          <dt className={styles.label}>{group.label}</dt>
          <dd className={styles.items}>
            {group.items.map((item) => (
              <Chip key={item}>{item}</Chip>
            ))}
          </dd>
        </div>
      ))}
    </dl>
  </GlassSurface>
);
